"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var Parser_1 = require("../Parser");
var hooks_1 = require("preact/hooks");
var blog_citation_1 = require("../../utils/shopify-graphql/blog-citation");
var BlogCitation = function () {
    var _a = (0, hooks_1.useState)(null), data = _a[0], setData = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[3];
        (0, blog_citation_1.getBlogCitationData)(handle)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("p", { class: "blog-citation__header" }, "References:"),
        (0, preact_1.h)("p", { class: "blog-citation__reference" }, data.map(function (d, index) { return ((0, preact_1.h)("span", { key: d, class: "blog-citation__text" },
            (0, preact_1.h)("sup", null, index + 1),
            " ",
            (0, Parser_1.parse)(d),
            " ",
            index < data.length - 1 && '|',
            ' ')); }))));
};
exports.default = BlogCitation;
